export default {
    searchFilter: null,
    mode: false,
}